import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useAuth } from '../services/auth'
import * as ROUTES from '../constants/routes'

function LoginPage(): React.ReactElement {
  const { isAuthenticated, error, loginWithRedirect } = useAuth()
  const { pathname } = useLocation()
  const history = useHistory()

  if (error && error?.message.indexOf('parameter organization is invalid') !== -1) {
    loginWithRedirect({
      returnTo: window.location.origin,
    })
  }

  useEffect(() => {
    if (isAuthenticated) {
      if (pathname && pathname !== '/login') history.push(pathname)
      else history.push(ROUTES.HOME)
    } else {
      loginWithRedirect({
        returnTo: window.location.pathname,
      })
    }
  }, [isAuthenticated, history, loginWithRedirect, pathname])

  return <div />
}

export default LoginPage
